import {GetActionsOfRowSingleAction, GetContentDetailOfRowAction} from "../../../api/omnimap/omnimapActions";
import {toast} from "react-toastify";
import $ from "jquery";

export function ActionListener(instanceIds, actionIds, callback) {
    const totalLength = instanceIds.length;
    let totalCapturedActions = 0;
    // Loop all instances
    for(const instance of instanceIds){
        //Infinite loop that calls itself on every second
        (async function loop() {
            //Get running action ın instance
            GetActionsOfRowSingleAction(instance).then((res) =>{
                if(res.result.status !== "OK"){
                    throw Error('Request is not successful')
                }
                for (const action of res.data.stages_list){
                    for(const act of actionIds){
                        if(action.definition.identification === act) {
                            return setTimeout(loop, 2000);
                        }
                    }
                }
                totalCapturedActions++;
                if(totalCapturedActions === totalLength){
                    return callback();
                }
                return 0;

            }).catch((e) =>{
                alert('Error');
                console.log(e);
            })
        })();
    }
}
export function ActionListenerWorkRules(selectedIds, actions){
    let numberOfWorkRules = 0;
    let message = {
        pending:"Wacht a.u.b",
        error:"Geen werkregels aangemaakt.",
        success:"Aantal gemaakte werkregels is "
    };
    const func = new Promise((resolve, reject) => {
        ActionListener(selectedIds, actions,  () => {
            const totalLength = selectedIds.length;
            let handledActions = 0;
            for (const id of selectedIds) {
                GetContentDetailOfRowAction(id).then((tmpRes)=>{
                    numberOfWorkRules += tmpRes.data.content.status['aantalwerkregels'] || 0;
                    handledActions++;

                    if(totalLength === handledActions){
                        if (numberOfWorkRules === 0) {
                            reject()
                        } else {
                            resolve(numberOfWorkRules);
                        }
                    }
                })
            }
        })
    });

    toast.promise(new Promise((resolve, reject)=>{}), {
        pending:message.pending,
        error:"",
        success:""
    });

    func.then((res) => {
        toast.dismiss();
        toast.success( message.success + res);
    }).catch(()=> {
        toast.dismiss();
        toast.error(message.error)
    })

}

export function ActionListenerUnCheckAll(callback){
    $(".checkNone").on('click', callback)
}

export function ActionListenerUnCheckRow(callback){
    console.log('set')
    const dataTable = $('#example').DataTable();
    $('#example').on('click', 'tbody tr', function () {
        const data = dataTable.row( $(this) ).data();
        console.log( 'You clicked on '+data[0]+'\'s row' );
    } );
}